import { ApplicationExtraInformation } from '@axo/shared/data-access/types/loan_application/ExtraInformation';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const getApplicationExtraInfo =
  ({ url: { service: baseURL }, token }: IAPI) =>
  (loanApplicationID: string): Promise<ApplicationExtraInformation> =>
    send({
      baseURL,
      token,
      path: `/loan-application/${encodeURIComponent(
        loanApplicationID,
      )}/extra-info`,
      method: 'GET',
    });
